import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {PrlAuthenticationService} from '../../../shared/services/prl-authentication.service';
import {PrlAccountDataService} from '../../prl-dashboard/services/account/prl-account-data.service';
import {PrlLanguageService} from '../../prl-language/services/prl-language.service';
import {Subject} from 'rxjs';
import {distinctUntilChanged, filter, takeUntil} from 'rxjs/operators';
import {PrlChangePasswordDialogComponent} from '../prl-change-password-dialog/prl-change-password-dialog.component';
import {ChangePasswordPrlObj, MxNotificationService} from 'mx-core';

@Component({
    selector: 'prl-active-account',
    templateUrl: './prl-active-account.component.html',
    standalone: false,
    styleUrls: ['./prl-active-account.component.scss']
})
export class PrlActiveAccountComponent implements OnInit, OnDestroy {
    protected displayName = '';

    private destroy$ = new Subject<void>();

    constructor(
        public accountDataService: PrlAccountDataService,
        protected authService: PrlAuthenticationService,
        private readonly dialog: MatDialog,
        private readonly languageService: PrlLanguageService,
        private notificationService: MxNotificationService,
    ) {
    }

    ngOnInit() {
        this.authService.getAuthenticationObsr()
            .pipe(
                filter((u) => !!u),
                distinctUntilChanged(),
                takeUntil(this.destroy$)
            )
            .subscribe(() => {
                this.getCurrentAccount();
            });
    }

    getCurrentAccount() {
        this.accountDataService.getAccountDisplayName()
            .subscribe((name) => {
                this.displayName = name;
            });
    }

    openChangePasswordDialog(): void {
        let dialogRef = this.dialog.open(PrlChangePasswordDialogComponent, {
            width: '30%',
            panelClass: 'mx-dialog-panel-class',
            data: {
                title: this.getLabel('label.marketing.tools.copy.link'),
                message: this.getLabel('label.marketing.tools.copy.message'),
                type: 'warn'
            }
        })
        dialogRef.afterClosed().subscribe((passwordObj: ChangePasswordPrlObj) => {
            if (passwordObj) {
                this.notificationService.notify(
                    this.accountDataService.changePassword(passwordObj),
                    this.getLabel('label.modify.account.change.password.message')
                ).subscribe();
            }
        });
    }

    getLabel = (label: string): string => {
        return this.languageService.getLabel(label);
    };


    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }


}
